import React, { FC } from 'react';
import { Autocomplete, TextField, Box, Typography, InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { ProductionPlanningTemplate } from 'models/organization';

type AddProductionTemplateAutocompleteProps = {
    options: ProductionPlanningTemplate[];
    onTemplateSelected: (template: ProductionPlanningTemplate) => void;
};

const AddProductionTemplateAutocomplete: FC<AddProductionTemplateAutocompleteProps> = ({
    options,
    onTemplateSelected,
}) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.name}
            value={null}
            onChange={(_, value) => {
                if (value) {
                    onTemplateSelected(value);
                }
            }}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            disabled={!options.length}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={translate('orders:ADD_PRODUCTION_PLAN')}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <AddIcon fontSize="small" />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        ),
                    }}
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props} key={option._id}>
                    <Typography variant="body2">{option.name}</Typography>
                </Box>
            )}
            sx={{ minWidth: 220 }}
            blurOnSelect
        />
    );
};

export default AddProductionTemplateAutocomplete;
